export default function (o) {
  Object.assign(o, {
    verifyEmailAddress (token) { return this.server.post('verify-email-address', {token}) },
  })
}
